import React, {startTransition, useEffect} from 'react';
import {CheckoutAnimationView} from './CheckoutAnimationView';

const Begin = () => {
  const spinnerRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hideAnimation = () => {
      if (spinnerRef.current) {
        spinnerRef.current.style.display = 'none';
      }
    };
    window.addEventListener(END_ANIMATION, hideAnimation);

    return () => {
      window.removeEventListener(END_ANIMATION, hideAnimation);
    };
  }, []);

  useEffect(() => {
    const showAnimation = () => {
      if (spinnerRef.current) {
        spinnerRef.current.style.display = 'flex';
      }
    };
    window.addEventListener(SHOW_ANIMATION, showAnimation);

    return () => {
      window.removeEventListener(SHOW_ANIMATION, showAnimation);
    };
  }, []);

  return <CheckoutAnimationView ref={spinnerRef} />;
};

const Show = () => {
  useEffect(() => {
    startTransition(() => {
      const event = new Event(SHOW_ANIMATION);
      window.dispatchEvent(event);
    });
  }, []);

  return null;
};

const End = () => {
  const event = new Event(END_ANIMATION);
  window.dispatchEvent(event);

  return null;
};

export const CheckoutAnimation = {
  Begin, // only should be called once at the top level
  Show, // can be mounted multiple times to continue showing the animation if needed
  End, // mounted/called to end the animation
};

const END_ANIMATION = 'CHECKOUT_END_ANIMATION_EVENT';
const SHOW_ANIMATION = 'CHECKOUT_SHOW_ANIMATION_EVENT';
